<template>
  <v-card tile flat>
    <div class="heading text-center">Why Foodtag?</div>
    <v-row class="pa-10">
      <v-col cols="12" sm="4">
        <div class="d-flex justify-center align-start">
          <img class="rounded img" src="../assets/images/kiwi.jpeg" />
        </div>
      </v-col>

      <v-col class="d-flex justify-center align-center" cols="12" sm="8">
        <div class="body" style="max-width:70%">
          We are passionate about food, but we are even more passionate about
          balancing good food with health and wellbeing. Why is your food
          tagged? It is marked for it's quality. It is a mark assurance that the
          food is good for you and the environment.
          <br />
          From soil to soul.
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {};
</script>

<style scoped>
.img {
  display: block;
  width: 100%;
  height: auto;
}
</style>
